module.exports = __webpack_public_path__ + "static/media/18.7203ef03.jpeg";